import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Calendar } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Pie } from "react-chartjs-2";
import { RootState } from "reducers/rootReducer";
import type { CalendarMode } from 'antd/es/calendar/generateCalendar';
import dayjs from 'dayjs';
import moment from "moment";

const RSVPRespModal: FC<{ onClose?: () => void; rsvp?: any }> = ({
  onClose,
  rsvp,
}) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const { selectedItem } = useSelector(
    (state: RootState) => state.search
  );

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const [redrawCount, setRedrawCount] = useState<number>(0);

  const [chartData, setChartData] = useState<any>({
    labels: ["Yes", "No", "Maybe", "Not answered"],
    datasets: [
      {
        label: "Object detection",
        data: [0, 0, 0, 0],
        backgroundColor: [
          "#40CC52",
          "#FF5F25",
          "#FBAE16",
          "#463BBD",
          "#91A5C6",
          "#508AFA",
          "#000",
        ],
        borderWidth: 1,
      },
    ],
  });

  const dispatch = useDispatch();
  const handleOptionClick = (option: string) => {
    dispatch({
      type: "SEND_MESSAGE",
      payload: {
        message: `${rsvp.data.rsvpTitle} ${option}`,
        type: "rsvp-response",
        data: {
          response: option,
          responseTo: rsvp.id,
        },
      },
    });
    handleCancel();
  };

  const handleCalendarClick = (option: any) => {
    dispatch({
      type: "SEND_MESSAGE",
      payload: {
        message: `Scheduled on: ${option.format("MM/DD/YYYY")}`,
        type: "rsvp-response",
        data: {
          response: option.toDate().getTime(),
          responseTo: rsvp.id,
        },
      },
    });
    handleCancel();
  };

  useEffect(()=>{
    // let chartResponsesData = [0, 0, 0, 0];

    // const responses = rsvp.data.responseAnswers || {};
    // Object.keys(responses).map((key)=>{
    //   if(responses[key] === 'Yes'){
    //     chartResponsesData[0]++;
    //   }
    //   if(responses[key] === 'No'){
    //     chartResponsesData[1]++;
    //   }
    //   if(responses[key] === 'Maybe'){
    //     chartResponsesData[2]++;
    //   }
    // });
    // console.log('chartResponsesData', chartResponsesData);
    // let chartDataTemp = chartData;
    // chartDataTemp.datasets[0].data = chartResponsesData;

    // if(selectedItem){
    //   const totalMembers = Object.keys(selectedItem?.persistent?.static?.metadata?.members?.users ?? {}).length - 1;
    //   chartResponsesData[3] = totalMembers - chartResponsesData[0]- chartResponsesData[1] - chartResponsesData[2]
    // }

    // setChartData(chartDataTemp);
    // setRedrawCount(redrawCount + 1)

  }, [selectedItem]);

  const onPanelChange = (value: any, mode: CalendarMode) => {
    console.log(value, mode);
  };


  return (
    <Modal
      title={!rsvp ? "Add RSVP" : ""}
      visible={isModalVisible}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row className="mt-4 mb-4">
        <span>{rsvp.data.rsvpTitle}</span>
      </Row>
      {/* {rsvp?.senderId !== localStorage.getItem("RID") ? ( */}

      {(rsvp.data.type === "threeButtons" || rsvp.data.type === "yes-no") &&
        <Row className="tiles">
          <Col span={24}>
            <Row className="d-flex mb-4">
              <Col span={12} className="pr-2">
                <Button
                  onClick={() => {
                    handleOptionClick(rsvp.data.options.option1);
                  }}
                  className="beam-btn green-btn cover w-full"
                >
                  {rsvp.data.options.option1}
                </Button>
              </Col>
              <Col span={12} className="pl-2">
                <Button
                  onClick={() => {
                    handleOptionClick(rsvp.data.options.option2);
                  }}
                  className={`beam-btn w-full ${
                    !rsvp.data.options.option3 ? "cover orange-btn" : ""
                  }`}
                >
                  {rsvp.data.options.option2}
                </Button>
              </Col>
            </Row>
            <Row>
              {rsvp.data.options.option3 && (
                <Col span={24}>
                  <Button
                    onClick={() => {
                      handleOptionClick(rsvp.data.options.option3);
                    }}
                    className="beam-btn orange-btn cover w-full"
                  >
                    {rsvp.data.options.option3}
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      }


      {rsvp.data.type === "calendar" && 
        <Row className="tiles">
          <Calendar fullscreen={false} onPanelChange={onPanelChange} validRange={[moment(rsvp.data.startDate), moment(rsvp.data.endDate)]} onSelect={(date)=>{
            console.log('on date selected', date);
            handleCalendarClick(date)
          }} />
        </Row>
      }
      
      {/* // ) : (
      //   <Row>
      //     <Pie key={redrawCount} data={chartData} redraw />
      //   </Row>
      // )} */}
    </Modal>
  );
};

export default RSVPRespModal;
